import CIQClient, { HTTPClientResponse } from "./ciq-client";

type MaterialLinkInput = {
  bid_package_ids: string[];
  link_material_ids?: string[];
  unlink_material_ids?: string[];
  link_submittal_ids?: never;
  unlink_submittal_ids?: never;
  link_activities?: never;
  unlink_activity_ids?: never;
  planning_only_activity_date?: never;
};

type SubmittalLinkInput = {
  bid_package_ids: string[];
  link_submittal_ids?: string[];
  unlink_submittal_ids?: string[];
  link_material_ids?: never;
  unlink_material_ids?: never;
  link_activities?: never;
  unlink_activity_ids?: never;
  planning_only_activity_date?: never;
};

type ActivityLinkInput = {
  bid_package_ids: string[];
  link_activities?: { id: string; link_type: number }[];
  unlink_activity_ids?: string[];
  link_material_ids?: never;
  unlink_material_ids?: never;
  link_submittal_ids?: never;
  unlink_submittal_ids?: never;
  planning_only_activity_date?: never;
};

type PlanningOnlyActivityDateInput = {
  bid_package_ids: string[];
  planning_only_activity_date: string | null;
  /** Leave completed bid packages untouched (log inline / bulk edit). */
  skip_completed?: boolean;
  link_material_ids?: never;
  unlink_material_ids?: never;
  link_submittal_ids?: never;
  unlink_submittal_ids?: never;
  link_activities?: never;
  unlink_activity_ids?: never;
};

/** Returned by linkBidPackageV2 for planning-only (onsite estimate) date requests. */
export type TOnsiteEstimateUpdateSummary = {
  updated_ids: string[];
  skipped_completed_ids: string[];
  skipped_not_applicable_ids: string[];
};

export type LinkBidPackageInput =
  | MaterialLinkInput
  | SubmittalLinkInput
  | ActivityLinkInput
  | PlanningOnlyActivityDateInput;

export async function linkBidPackages(
  input: LinkBidPackageInput,
  projectToken: string
): Promise<HTTPClientResponse> {
  const response = await CIQClient.post({
    url: "/features/linkBidPackageV2",
    data: { input },
    config: {
      headers: {
        Authorization: `Bearer ${projectToken}`
      }
    }
  });

  if (response.success && response.data?.success === false) {
    return {
      ...response,
      success: false,
      errorMsg: response.data.error ?? "Failed to update Bid Package links"
    };
  }

  return response;
}
